/* eslint-disable no-console */
/* eslint no-undef: 0 */
import { create, all } from "mathjs";
import store from '../store/store'
import i18n from '../plugins/i18n.js'
const math = create(all, {});

export const connect = (device) => {
  return new Promise((resolve, reject) => {
    if (device.communication.communicationMethod == 'FETCH' || device.communication.communicationMethod == 'MEASURE') {
      cordova.plugins.CarenationDevicesPlugin.connect(device.identifier, device.communication.config.name, device.communication.config, function (response) {
        console.log('connected ...');
        resolve(response)
      }, function (err) {
        console.log(err)
        reject(err)
      })
    } else if (device.communication.communicationMethod == 'NOTIFY') {
      cordova.plugins.CarenationDevicesPlugin.scanForDevice(device.communication.communicationType, 60, {
        deviceName: device.communication.config.name,
        serviceUUIDs: device.communication.config.serviceUUIDs
      }, function (deviceDetails) {
        console.log(deviceDetails)

        cordova.plugins.CarenationDevicesPlugin.connect(device.identifier, device.communication.config.name, {
          autoReconnect: device.communication.config.autoReconnect
        }, function (deviceServiceDetails) {
          console.log('BLE Connection successful')
          resolve(deviceServiceDetails)
        }, function (err) {
          console.log(err)
          reject(err)
        })
      }, function (err) {
        console.log(err)
        reject(err)
      })
    }
  })
}

export const disconnect = (device) => {
  return new Promise((resolve, reject) => {
    cordova.plugins.CarenationDevicesPlugin.disconnect(device.identifier, device.communication.config.name, function () {
      console.log('disconnected ...');
      resolve(null)
    }, function (err) {
      console.log(err)
      reject(err)
    })
  })
}

export const getDeviceData = (device) => {
  return new Promise((resolve, reject) => {
    if (device.communication.communicationMethod == 'FETCH') {
      // eslint-disable-next-line
      cordova.plugins.CarenationDevicesPlugin.fetchData(device.identifier, device.communication.config.name, device.communication.config.parameterName, function (response) {
        resolve(response)
      }, function (err) {
        reject(err)
      })
    }
    else if (device.communication.communicationMethod == 'NOTIFY') {
      cordova.plugins.CarenationDevicesPlugin.read(device.identifier, device.communication.config.name, device.communication.config.parameterName, function (data) {
        resolve(data)
      }, function (err) {
        console.log(err)
        reject(err)
      })
    }
  })
}

export const vitalsFetch = async (device, scb, ecb) => {
  try {
    await connect(device);
    let data = await getDeviceData(device);
    await disconnect(device);
    return data
  } catch (e) {
    throw e
  }
}

export const delay = (timeout) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve()
    }, timeout);
  })
}

export const startVitalsMeasure = async (device, vital, scb, ecb) => {
  try {
    console.log("startVitalsMeasure --", vital.identifier);
    await connect(device);
    await delay(3000)
    if (vital.identifier == 'glucose') {
      await minttiSetTestPaper(device)
      await delay(2000)
    }
    subscribeToDeviceDataWithCallBack(device, scb, ecb);
    await delay(2000)
    await doOperation(device, "startMeasure", { type: vital.identifier });
  } catch (e) {
    ecb(e)
  }
}

export const triggerStartVitalsMeasure = async (endpointName, device, vital) => {
  try {
    socket.emit('control-hub:startmeasure', {
      endpoint: endpointName,
      device: device.identifier,
      vital: vital.identifier
    })
  } catch (e) {
    ecb(e)
  }
}

export const stopVitalsMeasure = async (device, vital, scb, ecb) => {
  try {
    await doOperation(device, "stopMeasure", { type: vital.identifier });
    await unsubscribeToDeviceData(device);
    let data = await disconnect(device);
    scb(data)
  } catch (e) {
    ecb(e)
  }
}

// glucose
export const minttiSetTestPaper = async (device) => {
  let testParams = {
    testPaperManufacturer: 'Yi_Cheng',
    testPaperCode: 'C21'
  }
  let res = await doOperation(device, "setTestPaper", testParams);

  return res

}

export const getBatteryValue = async (device) => {
  try {
    let res = await doOperation(device, "getBatteryValue", {});
    return res
  } catch (e) {
    throw e
  }
}

export const isCharging = async (device) => {
  try {
    let res = await doOperation(device, "isCharging", {});
    return res
  } catch (e) {
    throw e
  }
}


export const subscribeToDeviceData = function (device) {
  let notifications = device.communication && device.communication.config && device.communication.config.notifications && device.communication.config.notifications.length > 0 ? device.communication.config.notifications.map(n => n.identifier) : [];
  return new Promise((resolve, reject) => {
    cordova.plugins.CarenationDevicesPlugin.startNotifications(device.identifier, device.communication.config.name, notifications, function (notification) {
      resolve(notification)
    }, function (err) {
      console.log(err)
      reject(err)
    });
  });
}

export const subscribeToDeviceDataWithCallBack = function (device, scb, ecb) {
  let notifications = device.communication && device.communication.config && device.communication.config.notifications && device.communication.config.notifications.length > 0 ? device.communication.config.notifications.map(n => n.identifier) : [];
  cordova.plugins.CarenationDevicesPlugin.startNotifications(device.identifier, device.communication.config.name, notifications, function (notification) {
    if (scb) {
      scb(notification)
    }
  }, function (err) {
    if (ecb) {
      ecb(err)
    }
  });
}

//TODO: Call only if device is connected
export const unsubscribeToDeviceData = function (device) {
  let notifications = device.communication && device.communication.config && device.communication.config.notifications && device.communication.config.notifications.length > 0 ? device.communication.config.notifications.map(n => n.identifier) : [];
  return new Promise((resolve, reject) => {
    cordova.plugins.CarenationDevicesPlugin.stopNotifications(device.identifier, device.communication.config.name, notifications, function () {
      cordova.plugins.CarenationDevicesPlugin.disconnect(device.identifier, device.communication.config.name, function () {
        resolve(true)
      }, function (err) {
        console.log(err)
        reject(err)
      })
    }, function (err) {
      console.log(err)
      reject(err)
    });
  })
}


export const updateDeviceSettings = function (device, settingName, settingValue) {
  return new Promise((resolve, reject) => {
    cordova.plugins.CarenationDevicesPlugin.updateSettings(device.identifier, device.communication.config.name, settingName, settingValue, function () {
      resolve(null)
    }, function (err) {
      console.log(err)
      reject(err)
    })
  })
}

export const doOperation = function (device, operationName, operationParams) {
  console.log('calling the do operation ..', operationName);
  console.log('device : ', device);
  console.log('cordova check : ', cordova.plugins.CarenationDevicesPlugin);
  return new Promise((resolve, reject) => {
    cordova.plugins.CarenationDevicesPlugin.doOperation(device.identifier, device.communication.config.name, operationName, operationParams, function (data) {
      resolve(data)
    }, function (err) {
      console.log(err);
      reject(err)
    })
  })
}

export const doOperationWithCallBacks = function (device, operationName, operationParams, scb, ecb) {
  cordova.plugins.CarenationDevicesPlugin.doOperation(device.identifier, device.communication.config.name, operationName, operationParams, function (data) {
    if (scb) {
      scb(data)
    }
  }, function (err) {
    if (ecb) {
      ecb(err)
    }
  })
}

export const initSubscribe = async function (deviceProfiles, cb) {
  if (deviceProfiles && deviceProfiles.length > 0) {
    for (let profile of deviceProfiles) {
      if (profile.communication.communicationMethod == 'NOTIFY') {
        try {
          await connect(profile);
          let notification = await subscribeToDeviceData(profile);
          cb(null, notification)
        } catch (err) {
          cb(err)
        }
      }
    }
  }
}

export const ocr = (device, imageData) => {
  return new Promise((resolve, reject) => {
    let params = {
      imageData: imageData,
      config: device.communication.config
    }

    cordova.plugins.CarenationDevicesPlugin.doOperation(device.identifier, device.communication.config.name, 'ocr', params, function (data) {
      resolve(data)
    }, function (err) {
      console.log(err)
      reject(err)
    })
  })
}

export const handleUnitConversion = (unitMetadata, reading) => {
  //reading.unit = reading.unit.toLowerCase();
  if (reading.unit == unitMetadata.primary) {
    return reading;
  }

  if (isNaN(reading.value)) {
    return reading;
  }

  if (unitMetadata.secondary) {
    var conversionStr = unitMetadata.secondary[reading.unit];
  } else {
    return reading;
  }

  if (!conversionStr) {
    return reading;
  }

  var conversionFunc = math.eval("f(x) = " + conversionStr);
  var convertedVal = conversionFunc(Number(reading.value));
  reading.value = convertedVal;
  reading.unit = unitMetadata.primary;

  return reading;
}

export const syncAppleHealthKit = (device) => {
  return new Promise(async (resolve, reject) => {
    try {
      let vitals = device.vitals.map((v) => v.identifier);
      await doOperation(device, "requestAuthorization", {
        dataTypes: [{ read: vitals }]
      });
      console.log("HealthKit authorized");
      let startDate = 0;
      if (localStorage.startDate) {
        startDate = Number(localStorage.startDate);
      }
      let endDate = new Date().getTime();
      let response = await doOperation(device, "sync", { dataTypes: vitals, endDate: new Date(endDate), startDate: new Date(startDate) });
      let responseToReturn = JSON.parse(JSON.stringify(response));
      localStorage.startDate = endDate;
      console.log(response);
      let user = JSON.parse(localStorage.user)

      response.data.forEach((measuredVital) => {
        let vital = device.vitals.find((v) => v.identifier == measuredVital.type)

        let convertedVital = handleUnitConversion(
          measuredVital.unit,
          {
            name: measuredVital.type,
            value: Number(measuredVital.value),
            unit: measuredVital.unit,
          }
        );

        if (convertedVital.value % 1 == 0) {
          measuredVital.value = convertedVital.value;
        } else {
          measuredVital.value = math.format(convertedVital.value, {
            notation: "fixed",
            precision: 2,
          });
        }
        measuredVital.unit = convertedVital.unit;
        measuredVital.timestamp = measuredVital.dateTime;
        measuredVital.name = vital.identifier
      });

      let vitalsData = [];

      //Generating vitals data object to save
      for (let vital of response.data) {
        if (Number(vital.value)) {
          vitalsData.push({
            patientId: user.patientId,
            value: Number(vital.value),
            name: vital.name,
            unit: vital.unit,
            provider: response.deviceType,
            timestamp: new Date(vital.timestamp),
          });
        }
      }
      console.log(vitalsData);

      if (vitalsData && vitalsData.length && vitalsData.length > 0) {
        await store.dispatch("saveVitalsData", vitalsData);

        window.socket.emit("latestVitalsUpdate", {
          caregroupId:
            user.caregroup._id || user.caregroup,
          patientId: user.patientId,
        });
      }

      resolve(responseToReturn)
    } catch (err) {
      reject(err)
    }
  })
}

export const syncGoogleFit = (device) => {
  return new Promise(async (resolve, reject) => {
    try {

      let googleFitAvailable = await isGoogleFitAvailable(device)
      if (googleFitAvailable) {
        let vitals = device.vitals.map((v) => v.identifier);

        await requestGoogleFitAuthorization(device)
        let startDate = Date.now() - (2 * 30 * 24 * 60 * 60 * 1000);
        if (localStorage.googleFitDataStartDate) {
          startDate = Number(localStorage.googleFitDataStartDate);
        }
        let endDate = new Date().getTime();
        let response = await doOperation(device, "sync", { dataTypes: vitals, endDate: new Date(endDate), startDate: new Date(startDate) });
        let responseToReturn = JSON.parse(JSON.stringify(response));
        localStorage.googleFitDataStartDate = endDate;
        let user = JSON.parse(localStorage.user)

        response.data.forEach((measuredVital) => {
          let vital = device.vitals.find((v) => v.identifier == measuredVital.type)

          let convertedVital = handleUnitConversion(
            measuredVital.unit,
            {
              name: measuredVital.type,
              value: Number(measuredVital.value),
              unit: measuredVital.unit,
            }
          );

          if (convertedVital.value % 1 == 0) {
            measuredVital.value = convertedVital.value;
          } else {
            measuredVital.value = math.format(convertedVital.value, {
              notation: "fixed",
              precision: 2,
            });
          }
          measuredVital.unit = convertedVital.unit;
          measuredVital.timestamp = measuredVital.dateTime;
          measuredVital.name = vital.identifier
        });

        let vitalsData = [];

        //Generating vitals data object to save
        for (let vital of response.data) {
          if (Number(vital.value)) {
            vitalsData.push({
              patientId: user.patientId,
              value: Number(vital.value),
              name: vital.name,
              unit: vital.unit,
              provider: response.deviceType,
              timestamp: new Date(vital.timestamp),
            });
          }
        }
        console.log(vitalsData);

        if (vitalsData && vitalsData.length && vitalsData.length > 0) {
          await store.dispatch("saveVitalsData", vitalsData);

          window.socket.emit("latestVitalsUpdate", {
            caregroupId:
              user.caregroup._id || user.caregroup,
            patientId: user.patientId,
          });
        }

        resolve(responseToReturn)

      } else {
        await promptGoogleFitInstall(device)
      }


    } catch (err) {
      reject(err)
    }
  })
}

export const isGoogleFitAvailable = async function (device) {
  return await doOperation(device, 'isAvailable', {})
}

export const promptGoogleFitInstall = async function (device) {
  return await doOperation(device, 'promptInstall', {})
}

export const requestGoogleFitAuthorization = async function (device) {

  let vitals = device.communication.config.init.operationParameters[0].read


  let authorized = await doOperation(device, "requestAuthorization", {
    dataTypes: [{ read: vitals }]
  });
  return authorized
}
